<template>
<transition name="fade">
  <div v-if="!state.loading">
    <div class="d-flex flex-wrap flex-stack my-5">

        <h2 v-if="state.allEtat && state.allEtat.length > 0" class="fw-bold my-2 d-none d-md-block text-uppercase text-white custom-title">
          Vos informations mensuelles
        </h2>

        <div v-if="state.allEtat && state.allEtat.length > 0" class="d-flex align-items-center my-2 w-100 w-md-auto">

          <button class="btn btn-primary w-100 w-md-auto" title="ajouter" @click="checkMonth(state.moisCourant)">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr075.svg" />
              </span>
            Nouvelle saisie
          </button>
        </div>
        <!--end::Controls-->
      </div>
      <el-empty v-if="state.allEtat.length == 0"  description="Aucune saisie pour le moment...">
        <br><el-button type="primary" @click="openEtatEmp()" >Créer votre première saisie !</el-button>
      </el-empty>
      <div class="row g-6 g-xl-9" v-if="state.allEtat && state.allEtat.length > 0">
        <div class="col-sm-6 col-xl-4" v-for="eem in state.allEtat" :key="eem.eem_seq">
          <div class="card h-100">
            <CardEtatEmp
              card-classes="h-100 border-hover"
              :eem_libelle="eem.eem_libelle"
              :eem_repas_mois="eem.eem_repas_mois"
              :eem_kms_mois="eem.eem_kms_mois"
              :eem_usage_voiture_perso="eem.eem_usage_voiture_perso"
              :eem_usage_voiture_pro="eem.eem_usage_voiture_pro"
              :eem_x_conges="eem.eem_x_conges"
              :eem_tot_heures_hno="eem.eem_tot_heures_hno"
              color="primary"
              :eem_status="eem.eem_status"
              footer-text=""
              arrow="Up-right"
              :indicator-label="`Créee le ${toDate(eem.eem_date)}`"
              @click="openEtatEmp(eem.eem_seq)" 
              :all="true"
            ></CardEtatEmp>
          </div>
        </div>

      </div>

      <el-drawer v-model="state.openCloseEtatAddEdit" :with-header="false" size="900px" modal-class="modal-transp" :lock-scroll="false" :show-close="false">
        <EtatAddEdit apiName="getEtatEmp"  :idEtat="state.EtatAddEdit" :isOpen="state.openCloseEtatAddEdit" :key="state.openCloseEtatAddEdit" @refresh="refresh" @closeEtatAddEdit="state.openCloseEtatAddEdit = 0"/>
      </el-drawer>

    </div>
  </transition>
</template>
  
  <script lang="ts">
  import { defineComponent, ref, onMounted, reactive } from "vue";
  import mAxiosApi from "@/api";
  import * as moment from "moment";
  import EtatAddEdit from "./EtatAddEdit.vue";
  import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
  import CardEtatEmp from "./CardEtatEmp.vue";
  import { ElMessage, ElMessageBox } from "element-plus";
   
  export default defineComponent({
    name: "General",
    components : {
        CardEtatEmp,
        EtatAddEdit,
    },
    setup() {

    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const disabled = ref(false)

    const state = reactive({
        allEtat : {} as any,
        EtatAddEdit : 0,
        openCloseEtatAddEdit : 0,
        loading : true,
        moisCourant: ''
    });
    
    onMounted(async() => {
      setCurrentPageBreadcrumbs("Saisie employé", ["Pages", "Profile"]);

      computeMoisCourant();

      await refresh();

      state.loading = false;

      console.log('current month :', state.moisCourant);

    });

    const computeMoisCourant = () => {
      // Récupérer le jour actuel
      const jourActuel = moment.default().date();
      
      let lib;
      
      // Appliquer la même logique que le backend
      if (jourActuel >= 1 && jourActuel <= 31) {
        // Du 1er au 20 : mois courant
        lib = moment.default().add(-1, 'month').locale('fr').format('MMMM YYYY');
      } else {
        // Du 21 au dernier jour : mois suivant
        lib = moment.default().locale('fr').format('MMMM YYYY');
      }
      
      // Mettre une majuscule au mois
      state.moisCourant = lib.charAt(0).toUpperCase() + lib.slice(1);
    };
  

      const toDate = (d) => {
        return moment.default(d).format("DD.MM.YYYY");
      };


      const openEtatEmp = (id = 0) =>{
        state.EtatAddEdit = id;
        state.openCloseEtatAddEdit = 1;
      }

      const refresh = async () => {
        const getEtatEmp = await mAxiosApi.prototype.getAxios("/getEtatEmp");
        state.allEtat = getEtatEmp.results;

      };

      const checkMonth = (mois) => {
        console.log('month eta: ', mois);
        const list = Array.isArray(state.allEtat) ? state.allEtat : [];
        const filteredList = list.filter(el => el.eem_libelle === mois);

        if (filteredList.length > 0) {
            ElMessage({
            type: 'error',
            message: `Vous avez déjà crée une saisie pour ${mois} ! Si votre saisie a été refusé, veuillez la modifier et la renvoyer au service RH svp.`,
          })
          return
        } else {
          openEtatEmp();
        }
      };
     
      return {
          disabled,
          dialogImageUrl,
          dialogVisible,
          state,
          toDate,
          openEtatEmp,
          refresh,
          computeMoisCourant,
          checkMonth
      };
    },
  });
  </script>